import lerpColor from 'app/functions/lerpColor'

const CompleteInIntervalCount = ({ dodone }) => {
  return (
    <div
      className="dodone-stats-base"
      style={{
        backgroundColor: lerpColor(dodone.stats.ratio, '#FF0000', '#00FF00')
      }}
    >
      <div>
        {dodone.stats.completed} of {dodone.stats.total}
      </div>
    </div>
  )
}

const StatusStreak = ({ dodone }) => {
  return (
    <div
      className="dodone-stats-base"
      style={{
        backgroundColor: dodone.isCompleted ? '#0A0' : '#F00'
      }}
    >
      <div>
        {dodone.stats.completed}
        {dodone.isCompleted && <> of {dodone.stats.total}</>}
      </div>
    </div>
  )
}

function resolveView(staterName) {
  if (staterName == 'StatusStreak') return StatusStreak
  if (staterName == 'CompleteInIntervalCount') return CompleteInIntervalCount
  return null
}

const DodoneStatsBase = ({ dodone }) => {
  const StatsComponent = resolveView(dodone.stats?.attributes?.name)

  if (!StatsComponent) return null

  return <StatsComponent dodone={dodone} />
}

export default DodoneStatsBase
